import React, { useState } from 'react'
import { environment } from '../../env';
import ViewPropertyCards from '../Modal/ViewPropertyCards'

function InvestorCard(props) {
    const { investorName, address, contact, email, image } = props;
    const [modal, setModal] = useState(false);
    const toggle = () => setModal(!modal);
    const addresssData = address.substring(0, 50);
    return (
        <div>
            <div className="card my-3 border-0 border-radius-15 shadow p-3 px-3 invasterCard"
                onClick={toggle}>
                <div className="row gx-3 align-items-center">
                    <div className="col-md-4 rounded" >
                        <div className="invastor-img-card">
                            {image == null || image == "" || image == undefined ? <img src="https://cdn.pixabay.com/photo/2015/10/05/22/37/blank-profile-picture-973460_960_720.png" className="invastor-img-cards" alt="invasterImage" /> : <img src={`${image}`} className="invastor-img-cards" alt="invasterImage" />}
                        </div>
                    </div>
                    <div className="col-md-8 mt-2">
                        <div className="card-body m-0 p-0">
                            <h5 className="fs-4 base-font-700 mb-3">Name: <span className='fs-4 base-font-400 '>{investorName}</span> </h5>
                            <h5 className="fs-4 base-font-700 mb-3">Contact: <span className='fs-4 base-font-400 '>{contact}</span> </h5>
                            <h5 className="fs-4 base-font-700 mb-3">Address: <span className='fs-4 base-font-400 '>{addresssData.length > 49
                                ? `${addresssData}...`
                                : addresssData}</span> </h5>
                            <h5 className="fs-4 base-font-700 mb-3">Email: <span className='fs-4 base-font-400 text-nowrap'>{email}</span> </h5>
                        </div>
                    </div>
                </div>
            </div>
            <ViewPropertyCards modal={modal} toggle={toggle} props={props} />
        </div>
    )
}

export default InvestorCard